import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { WhyEmprendeSection } from '../components/WhyEmprendeSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { WhatYouLearnSection } from '../components/WhatYouLearnSection';
import { WhoIsItForSection } from '../components/WhoIsItForSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FooterCTA } from '../components/FooterCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-slate-50 font-sans selection:bg-brand-green selection:text-white" data-id="element-152">
      <HeroSection data-id="element-153" />
      <WhyEmprendeSection data-id="element-154" />
      <BenefitsSection data-id="element-155" />
      <WhatYouLearnSection data-id="element-156" />
      <WhoIsItForSection data-id="element-157" />
      <TestimonialsSection data-id="element-158" />
      <PricingSection data-id="element-159" />
      <FooterCTA data-id="element-160" />
    </main>;
}